<template>
  <v-row v-if="mask_types">
    <v-col
      md="6"
      v-bind:key="mask_type._id"
      v-for="mask_type in mask_types"
      :align="align"
      no-gutters
    >
      <v-card
        class="my-7 border textCard pl-3"
        max-width="280"
        tile
        elevation="0"
        outlined
      >
        Plate {{ mask_type.code.replace("_", " ") }}:</v-card
      >
      <div v-if="!isNaN(mask_type.code.slice(-1))" class="my-6"></div>
      <Img
        v-if="isNaN(mask_type.code.slice(-1))"
        :value="`${path}/${mask_type.code}`"
        :height="110"
        :width="500"
      />
      <Img
        v-else
        :value="`${path}/${mask_type.code}`"
        :height="120"
        :width="1100"
      />
    </v-col>
  </v-row>
</template>
<script>
import Img from "../../shared/Img.vue";
export default {
  components: {
    Img,
  },
  props: {
    mask_types: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      ecu: this.$route.params.ecu,
      path: "plates",
      data: {},
    };
  },
  computed: {
    align() {
      if (this.$vuetify.breakpoint.width < 1300) {
        return "center";
      } else return "start";
    },
  },
};
</script>


